import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';

import Close24Icon from '../../../static/icons/ic_close_24.svg';
import { AriaAttributes, AriaRoles, messages as m } from '../../constants/AccessibilityConstants';
import { IconSizes } from '../../constants/Icon';
import { messages, TABS } from '../../constants/ShareModal';
import IconInteractive from '../lib/IconInteractive/IconInteractive';
import NavHorizontal from '../lib/NavHorizontal/NavHorizontal';

import ShareTabContent from './ShareTabContent';

import './ShareModal.scss';

class ShareModal extends React.Component {
  static propTypes = {
    // Define propTypes here
    // For now, pass in RowItem data directly to ShareModal. Use web state in the future
    onClose: PropTypes.func,
    intl: PropTypes.shape({
      formatMessage: PropTypes.func.isRequired,
    }).isRequired,
    showShareCoachmark: PropTypes.func,
    tabObjects: PropTypes.array.isRequired,
  };

  constructor(props, context) {
    super(props, context);
    const { tabObjects } = props;

    let tabs = tabObjects ? tabObjects.map(tabObject => tabObject.tab) : [];
    let selectedTabId = null;
    if (tabs.length > 0) {
      const tabsObject = this.updateSelectedTab(tabs, tabs[0].url);
      tabs = tabsObject.tabs;
      selectedTabId = tabsObject.selectedTabId;
    }
    this.state = {
      tabs,
      selectedTabId,
      showErrorMessage: false,
      errorMessage: '',
    };
  }

  static navHorizontalClasses = ['ShareModal__NavHorizontal'];

  updateSelectedTab = (tabs, selectedTabId) => {
    tabs.map(tab => {
      tab.isActive = false;
      if (tab.url === selectedTabId) {
        tab.isActive = true;
      }
    });

    return {
      tabs,
      selectedTabId,
    };
  };

  onLinkClicked = url => {
    this.setState({
      tabs: this.state.tabs.map(tab => {
        return {
          ...tab,
          isActive: tab.url === url,
        };
      }),
      selectedTabId: url,
      showErrorMessage: false,
    });
  };

  renderCloseIcon = () => {
    const {
      intl: { formatMessage: t },
    } = this.props;
    return (
      <div className='ShareModal__header__closeBtn'>
        <IconInteractive
          glyph={Close24Icon}
          onClick={this.props.onClose}
          size={IconSizes.small}
          tooltipText={t(messages.closeModal)}
        />
      </div>
    );
  };

  renderHeader = () => {
    return (
      <div className='ShareModal__header'>
        <span className='visuallyHidden'>
          <FormattedMessage {...m.menuTrapScreenReaderText} />
        </span>
        {this.state.tabs.length && this.state.tabs.length > 1 ? (
          <NavHorizontal
            links={this.state.tabs}
            onLinkClicked={this.onLinkClicked}
            navType={TABS}
          />
        ) : (
          <div className='ShareModal__header__text'>
            <FormattedMessage {...this.state.tabs[0].label.props} />
          </div>
        )}
        {this.renderCloseIcon()}
      </div>
    );
  };

  renderBody = () => {
    const { selectedTabId } = this.state;
    const { tabObjects } = this.props;

    return tabObjects.map(tabObject => {
      const isActive = tabObject.tab.url === selectedTabId;
      return (
        <ShareTabContent
          key={tabObject.sourceId}
          isActive={isActive}
          tabObject={tabObject}
          onClose={this.props.onClose}
          showShareCoachmark={this.props.showShareCoachmark}
        />
      );
    });
  };

  renderError = () => {
    const ariaAttributes = {};
    ariaAttributes[AriaAttributes.ATOMIC] = true;
    ariaAttributes[AriaAttributes.LIVE] = 'assertive';
    ariaAttributes.role = AriaRoles.ALERT;
    return (
      <div className='ShareModal__error' {...ariaAttributes}>
        <h5 className='ShareModal__error__message'>{this.state.errorMessage}</h5>
      </div>
    );
  };

  render() {
    return (
      <div className='ShareModal'>
        {this.renderHeader()}
        {this.renderBody()}
        {this.state.showErrorMessage && this.renderError()}
      </div>
    );
  }
}

export default injectIntl(ShareModal);
